/**
 * 알림 토스트 라벨 (Shell 전속)
 *
 * 표준 F-03 §7.6 — 토스트 라벨은 알림 유형 공통코드(ZEU_NOTI_TYPE)의 코드명을 쓴다.
 * 공통코드는 GET /indipia/init 응답(useAppStore.codes)에서 읽는다.
 * 유형 코드명이 없으면 표시 카테고리(ZEU_NOTI_CATEGORY) 코드명, 그것도 없으면 '알림'.
 * 원시 에이전트 코드(SYS·A01 등)는 노출하지 않는다.
 */
import type { CodeItem } from '@indipia/shared';
import type { NotificationItem } from './types';

const NOTI_TYPE_GROUP = 'ZEU_NOTI_TYPE';
const NOTI_CATEGORY_GROUP = 'ZEU_NOTI_CATEGORY';

export function resolveSourceLabel(item: NotificationItem, codes: CodeItem[]): string {
  const find = (group: string, value: string | null | undefined) =>
    value ? codes.find((c) => c.codeGroupCode === group && c.codeValue === value)?.codeName : undefined;
  return (
    find(NOTI_TYPE_GROUP, item.notiType) ??
    find(NOTI_CATEGORY_GROUP, item.notiCategory) ??
    '알림'
  ).trim();
}
